var remote = inElectron() ? require('electron').remote : false;

(function ($, Promise) {

		// Setup the prototype inheritance
		extend(BaseGame, BaseGameLYVLC);

		// Constructor
		function BaseGameLYVLC(dataFile) {

			// Super constructor
			BaseGame.call(this);
			this.i18n.set("fr");

			// Data
			this.settingsFile = 'settings.json';
			this.dataFile = dataFile;
			this.data = false;

			// Screensaver
			this.screensaverTimeline = false;
			this.screenAnimTimeline = false;
			this.stillThereTimeout = false;
			this.initalScreenInterval = false;
			this.initalScreenIntervalDuration = 5000;

			// Wait for all
			Promise.all([
				this.loadSettings(),
			]).then($.proxy(function () {
				return Promise.all([
					this.showIdentificationScreen(),
					this.loadData()
				]);
			}, this)).then($.proxy(function () {
				// Build content
				return this.buildContent();
			}, this)).then($.proxy(function () {
				// Replace strings {{ }}
				return this.replaceWithData();
			}, this)).then($.proxy(function () {
				// Serial port init
				return this.initSerialPort();
			}, this)).then($.proxy(function () {
				// Real game init
				return this.initGame();
			}, this)).catch($.proxy(function (error) {
				console.error("error", error)
				$("#main").append("<div id='error' style='padding: 20px;position: fixed;font-weight: bold;z-index: 1000;width: 600px;background: #e6d7d7;top: 10px;left: 660px;border: solid #c3a4a4 1px;'>Error: " + error.message + "</div>")
			}, this));

		}

		// Load settings JSON (with promise)
		BaseGameLYVLC.prototype.loadSettings = function () {
			return new Promise($.proxy(function (resolve, reject) {

				$.getJSON(this.settingsFile).done($.proxy(function (data) {
					this.settings = data;

					// Init screensaver
					if (typeof this.settings.screensaver_delay != "undefined") {
						this.screensaverDelay = this.settings.screensaver_delay;
					}

					// Remove arduino simulator if requested
					if (typeof this.settings.arduino_simulator != "undefined" && this.settings.arduino_simulator == false) {
						$(".arduino-simulator, #printed-guide").remove();
					}

					// Remove arduino simulator if requested
					if (typeof this.settings.serial != "undefined") {
						this.buttons = this.settings.serial;
					}

					resolve();

				}, this)).fail(function () {
					alert("The settings.json file was not found. Please add the setting file and restart app.");
					if (remote) {
						remote.app.quit();
					}

					reject();
				});
			}, this));
		};

		// Load data JSON (with promise)
		BaseGameLYVLC.prototype.loadData = function () {
			return new Promise($.proxy(function (resolve, reject) {
				$.getJSON(this.dataFile).done($.proxy(function (data) {
					this.data = data;
					resolve();
				}, this)).fail(function () {
					alert("No data found. Please add the data file and restart the app.");
					reject();
				});
			}, this));
		};

		BaseGameLYVLC.prototype.initSerialPort = function () {
			return new Promise($.proxy(function (resolve, reject) {

				console.log("Serial Port : init serial port")

				// Init serial ports servers
				this.serial = new Serial(9600, "Arduino", 1, false);

				if (this.serial.runningFromBrowser) {
					requestAnimationFrame($.proxy(function () {
						console.log("Serial Port : serial-ready : running from browser");
						resolve();
					}, this));
				}

				this.serial.on("serial-ready", $.proxy(function (e) {
					console.log("Serial Port : serial-ready");
					this.serial.on("message", $.proxy(this.onMessage, this));
					resolve();
				}, this));

				this.serial.on("serial port closed", $.proxy(function (e) {
					console.warn("Serial Port : closed");
				}, this));

				this.serial.on("serial-unavailable", $.proxy(function () {
					console.warn("No serial ports available for Arduino.");
					reject(new Error("No serial port matching Arduino available."));
				}, this));

				this.serial.on("error", $.proxy(function (e) {
					console.log("Serial Port : error", e);
					reject(e);
				}, this));

			}, this));
		}

		// To be overriden in child games
		BaseGameLYVLC.prototype.onMessage = function (e) {
			var message = e.message;
		}

		// Simulate a message receiving
		BaseGameLYVLC.prototype.simulateMessage = function (receivedString) {
			var event = $.Event('message');
			event.message = receivedString;
			this.onMessage(event);
		}

		// Parse elements to find "twig-like"  markup and replace with value
		BaseGameLYVLC.prototype.replaceWithData = function (e) {
			return new Promise($.proxy(function (resolve, reject) {
				var all = $("#main *");
				for (var i = 0; i < all.length; i++) {
					var $el = $(all[i]);
					var elText = $el.get(0).innerHTML;
					if (elText.startsWith("{{") && elText.endsWith("}}")) {
						var valueRoute = elText.substring(2, $el.text().length - 2);
						var explode = valueRoute.split(".");
						var value = this;
						for (var i2 = 0; i2 < explode.length; i2++) {
							value = value[explode[i2]];
						}
						$el.html(value)
					}
				}

				resolve();
			}, this));
		}

		// To be overriden in child games
		BaseGameLYVLC.prototype.buildContent = function () {
			return new Promise($.proxy(function (resolve, reject) {
				resolve();
			}, this));
		}

		// Show identification screen
		BaseGameLYVLC.prototype.showIdentificationScreen = function () {
			return new Promise($.proxy(function (resolve, reject) {
				this.goToScreen("onstart-identification");

				var duration = parseFloat(this.settings["identification_duration"]) * 1000;
				setTimeout($.proxy(function () {
					this.lockScreen = false;
					resolve();
				}, this), duration);

			}, this));
		};

		// To be overriden in child games
		BaseGameLYVLC.prototype.initGame = function () {
			this.startBurningScreenProtection();
			this.initScreenSaver();
			this.goToScreen(1);
		};

		// To be overriden in child games
		BaseGameLYVLC.prototype.initScreen = function (screenId) {

			// Super constructor
			if (BaseGame.prototype.initScreen.call(this, screenId) == false) {
				return false;
			}

			if (this.initalScreenInterval != false) {
				clearInterval(this.initalScreenInterval);
				this.initalScreenInterval = false;
			}

			if (this.requestedLanguage != false) {
				this.i18n.set(this.requestedLanguage);
				this.requestedLanguage = false;
			}

			switch (screenId) {
				case "onstart-identification":
					// setTimeout($.proxy(this.goToScreen, this, 1), 3000);
					return false;
					break;
				case 1:
					this.startBurningScreenProtection();
					this.initalScreenInterval = setInterval($.proxy(function () {
						this.i18n.flip();
						this.initScreenAudio(1);
					}, this), this.initalScreenIntervalDuration);
					break;
				default:
					this.stopBurningScreenProtection();
			}
		}

		// To be overriden in child games
		BaseGameLYVLC.prototype.initScreenAudio = function (screenId) {
		}

		BaseGameLYVLC.prototype.goToScreenSaver = function () {

			if ($("#still-there").hasClass("active")) {
				return false;
			}

			$("#still-there").addClass("active");
			this.openStillThereModal();
			this.stillThereTimeout = setTimeout($.proxy(function () {
				this.goToScreen(1);
				this.closeStillThereModal();
			}, this), 10000);
		}

		BaseGameLYVLC.prototype.openStillThereModal = function () {
			var tl = new TimelineMax();

			tl.to($("#still-there"), 0.5, {
				autoAlpha: 1
			});
			tl.fromTo($("#still-there .modal"), 0.5, {
				autoAlpha: 0,
				y: "-10px",
			}, {
				autoAlpha: 1,
				y: 0,
			});

			// Handle playback
			if (this.playlist) {
				this.playlist.clear();

				if (typeof this.data.content.still_there.audio != "undefined") {
					this.playlist.add(this.data.content.still_there.audio[this.i18n.lang]);
				}

				if (typeof this.data.content.still_there.audio_repeat != "undefined") {
					this.playlist.add(this.data.content.still_there.audio_repeat[this.i18n.lang], true, 3000);
				}

				this.playlist.play();
			}
		}

		BaseGameLYVLC.prototype.startBurningScreenProtection = function () {
			this.stopBurningScreenProtection();
			var intervalDuration = parseInt(this.settings["burning_screen_interval"]) * 1000;
			this.burningScreenInterval = setInterval($.proxy(function () {
				TweenMax.fromTo($("#burning-protect"), 3.5, {
					x: 0,
					ease: Linear.easeNone
				}, {
					x: 1920 + 100,
					ease: Linear.easeNone
				});
			}, this), intervalDuration)
		}

		BaseGameLYVLC.prototype.stopBurningScreenProtection = function () {
			if (this.burningScreenInterval != false) {
				clearInterval(this.burningScreenInterval);
				this.burningScreenInterval = false;
			}
		}

		BaseGameLYVLC.prototype.findAllAudioFiles = function (objectToParse) {
			return this.findAllExtensionFilesInObject(objectToParse, [".mp3", ".wav"]);
		}

		BaseGameLYVLC.prototype.closeStillThereModal = function () {

			if (this.stillThereTimeout != false) {
				clearTimeout(this.stillThereTimeout);
				this.stillThereTimeout = false;
			}

			TweenMax.to($("#still-there"), 0.5, {
				autoAlpha: 0,
				onComplete: function () {
					$("#still-there").removeClass("active");
				}
			});
		}

		BaseGameLYVLC.prototype.goToScreen = function (screenId, callback) {

			// Super constructor
			if (BaseGame.prototype.goToScreen.call(this, screenId, callback) == false) {
				return false;
			}

			// Protection to avoid language switching while user is selecting a language
			if (screenId != 1 && this.initalScreenInterval != false) {
				clearInterval(this.initalScreenInterval);
				this.initalScreenInterval = false;
			}
		}

		BaseGameLYVLC.prototype.restartApp = function () {
			if (inElectron()) {
				remote.getCurrentWindow().webContents.reloadIgnoringCache();
			}
		}

		// Reset values when we return to the homepage
		BaseGameLYVLC.prototype.reset = function (screenId) {

			if (typeof screenId == "undefined") {
				screenId = 1;
			}

			if (BaseGame.prototype.reset.call(this) == false) {
				return false;
			}

			if (this.stillThereTimeout != false) {
				clearTimeout(this.stillThereTimeout);
				this.stillThereTimeout = false;
			}

			// Return to idle screen
			this.goToScreen(screenId, $.proxy(function () {

				// Reset language
				if (this.i18n.lang == "en") {
					this.i18n.flip();
				}


			}, this));
		};

		// Expose BaseGameLYVLC
		window.BaseGameLYVLC = BaseGameLYVLC;
	}
)
(jQuery, Promise);
